// Admin-authored destinations (page header quick links, mega menu rows and
// tiles) pass SafeMenuUrl on the server: a relative path, a bare path like
// `products?brand=2`, or an http(s) URL. Relative ones belong to the SPA and
// should not reload it.

const EXTERNAL = /^https?:\/\//i

export const isExternalUrl = url => EXTERNAL.test(url)

export const internalPath = url => (/^[/?#]/.test(url) ? url : `/${url}`)

// Click handler for a plain <a> whose href is one of those destinations. Keeps
// internal links in the router; leaves external links, modified clicks and
// anchors without an href to the browser. Returns whether it took the click.
export function followInternalLink (event, router) {
  const anchor = event.target.closest('a')
  const href = anchor && anchor.getAttribute('href')

  if (!href || isExternalUrl(href) || event.metaKey || event.ctrlKey || event.shiftKey) {
    return false
  }

  event.preventDefault()
  router.push(internalPath(href)).catch(() => {})

  return true
}
